import { api } from './api';

// Default streams — admin-curated fallbacks served to devices that have
// no operator-assigned stream yet. Lookup chain on the player side:
//   1. Default stream whose group is among the device's organisation's groups
//   2. Default stream with group_id = NULL ("Allgemein")
//   3. Nothing
//
// These streams are kept out of the regular streams overview by the
// backend (`kind != default` filter on /api/streams) so they only show
// up in the dedicated admin page.
export const defaultStreamsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getDefaultStreams: build.query({
      query: () => ({ url: 'default-streams', method: 'GET' }),
      transformResponse: (r) => r.data || [],
      providesTags: (result) =>
        result
          ? [
            ...result.map((s) => ({ type: 'DefaultStreams', id: s.model?.ID })),
            { type: 'DefaultStreams', id: 'LIST' },
          ]
          : [{ type: 'DefaultStreams', id: 'LIST' }],
    }),
    createDefaultStream: build.mutation({
      query: (body) => ({
        url: 'default-stream',
        method: 'POST',
        body: JSON.stringify(body),
      }),
      invalidatesTags: (_r, e) => (e ? [] : [{ type: 'DefaultStreams', id: 'LIST' }]),
    }),
    deleteDefaultStream: build.mutation({
      query: (id) => ({ url: `default-stream/${id}`, method: 'DELETE' }),
      invalidatesTags: (_r, e) => (e ? [] : [{ type: 'DefaultStreams', id: 'LIST' }]),
    }),
  }),
});

export const {
  useGetDefaultStreamsQuery,
  useCreateDefaultStreamMutation,
  useDeleteDefaultStreamMutation,
} = defaultStreamsApi;
